import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import employees from './modules/employees';
import version from './modules/version';
import layout from './modules/layout';
import backArrow from './modules/back-arrow';
import document from './modules/document';
import vacation from './modules/vacation';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        employees,
        version,
        layout,
        backArrow,
        document,
        vacation
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js